import { Component, OnInit } from '@angular/core';
import { UserDataService } from 'src/app/_services/user.data.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  constructor(public userDataService: UserDataService) {}

  ngOnInit(): void {}
}
